import { jsxs as l, jsx as a } from "react/jsx-runtime";
import { useState as g, useEffect as z, Fragment as C } from "react";
import { useTranslation as k } from "@nextgen-web-framework/all";
import { getTimeDifference as h } from "../../utils/countDownUtil.js";
import '../../assets/CountdownTimer.css';const b = "#ffffff", _ = "#396e75", p = "#e5fdff", w = "#546223", B = "#f0fae5", G = "#a65523", O = "#fff1e8", v = "#7f3e3e", R = "#ffe2e2", W = "#62625a", y = "#f8f8e7", S = "#38539a", A = "#707070", I = "#c8f8d1", N = "#87c9c8", Y = "#5291b1", x = "rgba(82, 145, 177, 0.1019607843)", T = "#445685", j = "#181d61", D = "rgba(24, 29, 97, 0.1019607843)", P = "#5969d6", $ = "#ea999d", E = "#b6577e", F = "rgba(182, 87, 126, 0.1019607843)", q = "#7e3e80", H = "#1e247f", J = "rgba(30, 36, 127, 0.1019607843)", K = "#da7600", L = "#107f47", M = "#d91734", Q = "_html_12bel_38", o = {
  amwayWhite: b,
  darkBlue: _,
  lightBlue: p,
  darkGreen: w,
  lightGreen: B,
  darkOrange: G,
  lightOrange: O,
  darkRed: v,
  lightRed: R,
  darkYellow: W,
  lightYellow: y,
  darkPurple: S,
  darkGrayOnWhite: A,
  dataVizColor1: I,
  dataVizColor2: N,
  dataVizColor3: Y,
  dataVizColor3Background: x,
  dataVizColor4: T,
  dataVizColor5: j,
  dataVizColor5Background: D,
  dataVizColor6: P,
  dataVizColor7: $,
  dataVizColor8: E,
  dataVizColor8Background: F,
  dataVizColor9: q,
  dataVizColor10: H,
  dataVizColor10Background: J,
  dataVizAlertOrange: K,
  dataVizSuccessGreen: L,
  dataVizWarningRed: M,
  "no-visible": "_no-visible_12bel_34",
  html: Q,
  "timer-block": "_timer-block_12bel_72",
  "time-countdown-title": "_time-countdown-title_12bel_80",
  "time-info-block": "_time-info-block_12bel_88",
  "separator-dot": "_separator-dot_12bel_100"
}, ot = ({ endTime: e, title: d, customClass: i }) => {
  const c = k(), [r, s] = g({
    hours: 0,
    minutes: 0,
    seconds: 0,
    isAhead: !1
  }), n = () => {
    s(h(e));
  };
  z(() => {
    n();
    const t = setInterval(n, 1e3);
    return () => clearInterval(t);
  }, [e]);
  const f = (t) => String(t).padStart(2, "0"), { isAhead: u } = r;
  return u ? /* @__PURE__ */ l("div", { className: `${o["timer-block"]} ${i}`, children: [
    /* @__PURE__ */ a("span", { className: o["time-countdown-title"], "data-testid": "countdown_title_testId", "data-pod-name": "commerce", children: d ?? c("web.countdowntimer.title") }),
    ["hours", "minutes", "seconds"].map((t, m, V) => /* @__PURE__ */ l(C, { children: [
      /* @__PURE__ */ a("span", { className: o["time-info-block"], children: f(r[t]) }),
      m !== V.length - 1 && /* @__PURE__ */ a("span", { className: o["separator-dot"], children: ":" })
    ] }, t))
  ] }) : null;
};
export {
  ot as default
};
//# sourceMappingURL=CountdownTimer.js.map
